import React from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Api } from 'vl-common/src/api';
import type { Case } from 'vl-common/src/schemas/shared';
import { confirmationModal } from 'vl-common/src/components/Modals';
import toast from 'react-hot-toast';
import i18n from 'vl-common/src/lib/i18n';

const t = i18n.getFixedT(null, 'common');

export const updateCaseSubSpecialty = async (caseData: Case, refetch: () => void) => {
  const formId = `updateCaseSubSpecialty-${caseData.case_id}`;

  const { data } = await Api.admin.getSpecificAreas({ rows: 999 });

  const filteredSpecAreas = data?.areas?.filter(
    (area) => area.category_code === caseData.spec_cat_code && area.area_code !== caseData.case_spec_area_code
  );

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const selectElement = 'specarea' in e.target ? (e.target.specarea as HTMLSelectElement) : null;
    const selectedValue = selectElement.value;

    if (!selectElement) return toast.error('Failed to update case sub-specialty');

    try {
      await Api.cases.updateArea(caseData.case_id, selectedValue);
      refetch();
      return toast.success('Case sub-specialty updated');
    } catch (err) {
      const message =
        err instanceof Error &&
        'response' in err &&
        err.response instanceof Response &&
        'data' in err.response &&
        typeof err.response.data === 'object' &&
        'message' in err.response.data &&
        typeof err.response.data.message === 'string'
          ? err.response.data.message
          : 'Failed to update case sub-specialty';

      return toast.error(message);
    }
  };

  return confirmationModal({
    title: 'Update case sub-specialty',
    icon: null,
    content: (
      <Form id={formId} onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="specarea">{t('New sub-specialty')}</Label>

          <Input id="specarea" name="select" type="select" required>
            {filteredSpecAreas?.map((area) => (
              <option key={area.area_code} value={area.area_code}>
                {area.area_name}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Form>
    ),
    okButtonProps: {
      htmlType: 'submit',
      form: formId
    }
  });
};
